import { delay } from 'q'
import { UserInvite, APIClientInterface, ListResponse, SingleResponse, UserInviteServiceInterface, UserInviteListItem } from '../types'
import { createFakeListResponse, createFakeSingleResponse } from './fakes/createFakeResponse'
import { userInviteListItems, userInvites } from './fakes/userInvites'

export default class UserInvitesService implements UserInviteServiceInterface {
	constructor(private client: APIClientInterface) {}

	public async getAll(): Promise<ListResponse<UserInviteListItem>> {
		await delay(500)
		return createFakeListResponse(userInviteListItems)
	}

	public async create(): Promise<SingleResponse<UserInvite>> {
		await delay(500)
		const invite = {
			email: `test${Date.now()}@example.com`,
			service_provider_id: 2
		}
		userInvites.push(invite)
		userInviteListItems.push({
			email: invite.email,
			organizations: [{ id: 2, name: 'SP 2' }],
			organization_type: 'service_provider'
		})
		return createFakeSingleResponse(invite)
	}

	public async get(): Promise<SingleResponse<UserInvite>> {
		await delay(500)
		return createFakeSingleResponse(userInvites[0])
	}

	public async claim(): Promise<SingleResponse<UserInvite>> {
		await delay(500)
		return createFakeSingleResponse(userInvites[0])
	}

	public async delete(email: string): Promise<void> {
		await delay(500)
		userInvites.splice(
			userInvites.findIndex(i => i.email === email),
			1
		)
		userInviteListItems.splice(
			userInviteListItems.findIndex(i => i.email === email),
			1
		)
	}
}
